import type { managePilots as en } from '@/i18n/locales/en/managePilots';
import type { Translation } from '@/i18n/types';

export const managePilots: Translation<typeof en> = {
  page: {
    title: 'Pilot',
    lead: 'Tutti i pilot della piattaforma, filtrabili per azienda e stato.',
    filterCompany: 'Azienda',
    filterStatus: 'Stato',
    allCompanies: 'Tutte le aziende',
    allStatuses: 'Tutti gli stati',
    empty: 'Nessun pilot corrisponde a questi filtri.',
    rowsLabel: 'i pilot',
    company: 'Azienda',
    name: 'Nome',
    status: 'Stato',
    startDate: 'Data di inizio',
    endDate: 'Data di fine',
    departments: 'Reparti',
  },
  status: {
    draft: 'Bozza',
    baseline: 'Misurazione iniziale',
    active: 'Attivo',
    interim_review: 'Valutazione intermedia',
    final_review: 'Valutazione finale',
    completed: 'Completato',
    scaled: 'Scalato',
  },
};
